const state = {
    tenants: [],
    tenantsId: [],
    tenantFields:[],
    logs: [],
    signature: [],
    id: [],
    configs: [],
    moduletype: [],
    loading: false,
    loadingLogs: false,
};

export default state;